// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.adIwt4w73n12LI8hOeva{width:100%;text-align:left}`, "",{"version":3,"sources":["webpack://./src/entities/Attachment/ui/AttachmentLink/styles.module.scss"],"names":[],"mappings":"AAAA,sBACE,UAAA,CACA,eAAA","sourcesContent":[".link{\n  width: 100%;\n  text-align: left;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"link": `adIwt4w73n12LI8hOeva`
};
export default ___CSS_LOADER_EXPORT___;
